import { MESSAGING_PROMPT_REQUEST_STORAGE_KEY } from "@/lib/messagingPromptRequest";

export function completeMessagingPromptRequest(viewerScope: string | undefined) {
  if (typeof window === "undefined" || !viewerScope) return;

  try {
    window.localStorage.removeItem(MESSAGING_PROMPT_REQUEST_STORAGE_KEY);
  } catch {
    // The in-memory hook state still prevents a duplicate prompt in this render lifecycle.
  }
}
